<template>
    <b-row class="match-height">
        <b-col md="4">
            <b-card>
                <b-card-title>
                    <b-avatar class="mr-1" :variant="`light-${getMenuColor('password')}`" size="45">
                        <feather-icon size="21" icon="KeyIcon"/>
                    </b-avatar>
                    <span>Password</span>
                </b-card-title>
                <div v-if="stateFlag" class="truncate text-center">
                    <h3 class="mb-25 font-weight-bolder">
                        <span v-if="getDateDiff(userInfo.passwdDt) < 90" :class="`text-${getMenuColor('password')}`">{{$t('org.auth.XDaysOld').replace('[DATE]', getDateDiff(userInfo.passwdDt))}}</span>
                        <span v-if="getDateDiff(userInfo.passwdDt) >= 90" :class="`text-${getMenuColor('password')}`">{{$t('org.auth.XDaysOld').replace('[DATE]', getDateDiff(userInfo.passwdDt))}}</span>
                    </h3>
                    <small v-if="getDateDiff(userInfo.passwdDt)<90">{{$t('org.auth.changePasswordBeforeXDays').replace('[DATE]', (90-getDateDiff(userInfo.passwdDt)))}}</small>
                    <small v-if="getDateDiff(userInfo.passwdDt)>=90">{{$t('org.auth.pleaseChangePassword')}}</small>
                </div>
                <div v-else class="d-flex justify-content-center">
                    <b-spinner label="Loading..." />
                </div>
            </b-card>
        </b-col>
        <b-col md="4">
            <b-card>
                <b-card-title>
                    <b-avatar class="mr-1" :variant="`light-${getMenuColor('otp')}`" size="45">
                        <feather-icon size="21" icon="LinkIcon"/>
                    </b-avatar>
                    <span>OTP</span>
                </b-card-title>
                <div v-if="stateFlag" class="truncate text-center">
                    <h3 class="mb-25 font-weight-bolder">
                        <span v-if="userInfo.otpEnabled" :class="`text-${getMenuColor('otp')}`">{{$t("org.auth.otpEnabled")}}</span>
                        <span v-if="!userInfo.otpEnabled" :class="`text-${getMenuColor('otp')}`">{{$t("org.auth.otpDisabled")}}</span>
                    </h3>
                    <small v-if="userInfo.otpEnabled">{{$t("org.auth.otpMakesYouSafe")}}</small>
                    <small v-if="!userInfo.otpEnabled">{{$t("org.auth.pleaseEnableOtp")}}</small>
                </div>
                <div v-else class="d-flex justify-content-center">
                    <b-spinner label="Loading..." />
                </div>
            </b-card>
        </b-col>
        <b-col md="4">
            <b-card>
                <b-card-title>
                    <b-avatar class="mr-1" :variant="`light-${getMenuColor('terms')}`" size="45">
                        <feather-icon size="21" icon="CheckCircleIcon"/>
                    </b-avatar>
                    <span>Terms & Condition</span>
                </b-card-title>
                <div v-if="stateFlag" class="truncate text-center">
                    <h3 class="mb-25 font-weight-bolder">
                        <span v-if="userInfo.singedTcDt" :class="`text-${getMenuColor('terms')}`">{{$t("org.auth.agreed")}}</span>
                        <span v-if="!userInfo.singedTcDt" :class="`text-${getMenuColor('terms')}`">{{$t("org.auth.notAgreed")}}</span>
                    </h3>
                    <small v-if="userInfo.singedTcDt">{{userInfo.singedTcDt}}</small>
                    <small v-if="!userInfo.singedTcDt">{{$t("org.auth.agreementIsRequired")}}</small>
                </div>
                <div v-else class="d-flex justify-content-center">
                    <b-spinner label="Loading..." />
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import { ref, computed, getCurrentInstance } from '@vue/composition-api'
export default {
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        /* data */
        const stateFlag = ref(false)

        /* computed */
        const userInfo = computed(() => store.getters.userInfo)

        /* methods */
        const getDateDiff = (date) => {
            const old = new Date(date)
            const now = new Date()
            return Math.floor((now - old) / 3600000 / 24)
        }
        const getMenuColor = (name) => {
            if (name === 'password') {
                const old = new Date(userInfo.value.passwdDt)
                const now = new Date()
                if (Math.floor((now - old) / 3600000 / 24) < 90) {
                    return 'success'
                } else {
                    return 'danger'
                }
            } else if (name === 'otp') {
                if (userInfo.value.otpEnabled) {
                    return 'success'
                } else {
                    return 'danger'
                }
            } else if (name === 'terms') {
                if (userInfo.value.singedTcDt) {
                    return 'success'
                } else {
                    return 'danger'
                }
            }
        }

        /* init */
        if (userInfo.value) stateFlag.value = true

        return {
            stateFlag,
            userInfo,
            getDateDiff,
            getMenuColor
        }
    }
}
</script>

<style>

</style>
